<template lang="pug">
  div#advisoryMap
    v-container#container-map(fluid)
      v-dialog(v-model="dialog" max-width="500")
        v-card
          v-card-media.headline(:src="postalImage" height="100%")

      v-layout.text-xs-center(row justify-center align-center)
        v-flex.text-xs-center(xs6 sm6 md3)
          p.resultado.mt-3.mb-0.pa-2.text-xs-center 
            span.uppercase.bold.small Resultado&nbsp;
            span.accent-text.larger.bolder {{ reports.length }}&nbsp;
            span.larger.bolder Asesorías

      v-layout(row wrap justify-center align-content-center)
        v-flex(xs12 sm9 xs9)
          #advisoryMapId
        v-flex.pl-1(xs12 sm9 md3)
          States

      //v-layout(row wrap)
        v-flex(xs12 sm12 md4)
          v-btn.btn-black.ml-2.mb-3(outline large color="black" @click="downloadData()") Descargar Datos

</template>

<script>
import L from "leaflet";
import States from "@/components/States";
import Card from "@/components/Card";
import * as _ from "lodash";
import * as d3 from "d3";

export default {
  name: "Map",

  data() {
    return {
      mymap: undefined,
      markers: [],
      markerLayer: undefined,
      dialog: false,
      postalImage: "",
    };
  },
  components: {
    States,
    Card
  },
  computed: {
    reports: {
      get() {
        return this.$store.state.filteredReports;
      }
    }
  },
  watch: {
    "$store.state.selection": function() {
      if (this.$store.state.selection) {
        let foundMarker = this.markers.find(marker => {
          return marker._leaflet_id == this.$store.state.selection;
        })
        if(foundMarker !== undefined) {
          foundMarker.fire("click");
        }
        else {
          this.$notify({
            type:' error ',
            group: 'foo',
            title: 'SIN LOCALIZACIÓN',
            text: 'El caso no cuenta con coordenadas a visualizar.'
          });
        }
      } else {
          this.mymap.closePopup();
      }
    },
    "$store.state.filteredReports": function() {
      this.drawMarkers();
    }
  },
  methods: {
    drawMap() {
      this.mymap = L.map("advisoryMapId", {
        maxBounds: L.latLngBounds([13.623811, -84.211313], [35.022183, -120.054401]),
      }).setView([21.732, -101.483], 5);
      this.mymap.scrollWheelZoom.disable();

      L.tileLayer(
        "https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}",
        {
          attribution:
            'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          id: "mapbox.streets",
          accessToken:
            "pk.eyJ1IjoibmVsbHktcmFtaXJleiIsImEiOiJjanJ3N3NyaHUwOGV0NDVuY2FleXc5YXB3In0.r1Gvt3uxgR8o36CcDMd3Bw"
        }
      ).addTo(this.mymap);

      this.mymap.on("popupclose", () => {
        this.$store.commit("setSelection", undefined);
      });

      this.drawMarkers();
    },
    drawMarkers() {
      this.markers = [];
      if (this.markerLayer) {
        this.markerLayer.clearLayers();
      }

      this.reports.forEach(report => {
        const svg = `
        <?xml version="1.0" encoding="UTF-8"?>
        <svg width="30px" height="37px" viewBox="0 0 30 37" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <circle cx="8" cy="8" r="8" fill="#752c7d"/>
        </svg>
        `;
        const advisoryIcon = L.divIcon({
          className: "pin",
          html: svg,
          iconAnchor: [16, 34],
          popupAnchor: [0, -35]
        });

        if (report.narrative.lastSeenLocation.lat !== null && report.narrative.lastSeenLocation.lng !== null) {
          let marker = L.marker(
            [parseFloat(report["lat"]), parseFloat(report["lng"])],
            { icon: advisoryIcon }
          );

          const tooltip = this.createTooltip(report);
          marker.bindPopup(tooltip);

          marker._leaflet_id = report.folio;
          marker.on("click", e => {
            const folio = e.sourceTarget._leaflet_id;
            this.$store.commit("setSelection", folio);
            marker.openPopup();
          });

          this.markers.push(marker);
        }
      });

      this.markerLayer = L.layerGroup(this.markers).addTo(this.mymap);
    },
    createTooltip(report) {
      const mapTooltip = d3.create("div");

      mapTooltip
        .append("p")
        .attr("class", "tooltip-text")
        .append("text")
        .text(report.victimData.sex ? report.victimData.sex : "No disponible, ");

      let postalInfoText = report.victimData.disappearanceAge ? `${report.victimData.disappearanceAge} años, ` : "No disponible, ";
      postalInfoText += report.year ? report.year : "No disponible";
      
      mapTooltip
        .append("p")
        .attr("class", "accent-text bold")
        .append("text")
        .text(postalInfoText);

      mapTooltip
        .append("p")
        .attr("class", "tooltip-text")
        .append("text")
        .text(report.victimData.disappearanceMun ? report.victimData.disappearanceMun : "No disponible");

      /*mapTooltip
        .append("button")
        .attr("class", "btn-popup")
        .text("Ver Postal")
        .on("click", () => {
          this.openPopup(report.postal.url);
        });*/

      return mapTooltip.node();
    },
    openPopup(postal) {
      this.dialog = true;
      this.postalImage = postal;
    },
    // downloadData() {
    //   let lineArray = [
    //     "data:text/csv;charset=utf-8,Folio,Fecha de desaparición, Estado, Municipio,Edad,Sexo"
    //   ];
    //   this.reports.forEach(infoArray => {
    //     let line = "";
    //     line += infoArray.folio + ",";
    //     line += infoArray.victimData.disappearanceDate + ",";
    //     line += infoArray.victimData.disappearanceState + ",";
    //     line += infoArray.victimData.disappearanceMun + ",";
    //     line += infoArray.victimData.disappearanceAge + ",";
    //     line += infoArray.victimData.sex;
    //     lineArray.push(line);
    //   });

    //   let csvContent = encodeURI(lineArray.join("\n"));
    //   var link = document.createElement("a");
    //   link.setAttribute("href", csvContent);
    //   link.setAttribute("download", "datos-asesorias.csv");
    //   document.body.appendChild(link);
    //   link.click();
    // },
    // showSelections(obj) {
    //   let selected = [];
    //   _.forEach(obj, val => {
    //     if (val.isSelected) {
    //       selected.push(val.text);
    //     }
    //   });
    //   return selected.join(", ");
    // }
  },
  mounted() {
    this.drawMap();
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800");

#advisoryMap {
  background-color: #f7f7f7;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 1rem;
}
#advisoryMapId {
  height: 600px;
  width: 98%;
  z-index: 0;
}

#container-map {
  padding: 0px 10% 0px 10%;
}

#map .btn-black {
  border-radius: 10px;
  font-weight: 600;
  border: 2px solid black !important;
  font-size: 12px;
  margin-top: 8%;
}

.note-line {
  margin-top: 20px;
  margin-bottom: 10px;
  width: 18%;
  border: 1px solid #be3117;
}

.note {
  font-size: 11px;
}

.italic {
  font-style: italic;
}

.busqueda {
  padding-right: 2%;
  font-size: 16px;
  margin-top: 10%;
}
#advisoryMap .resultado {
  background-color: black;
  color: #fff;
  display: block;
}

.leaflet-popup-content-wrapper {
  border-radius: 8px;
  width: 130px !important;
  background-color: rgba(1, 1, 1, 0.71);
  p {
    margin: 0px !important;
  }
}
.leaflet-popup-tip {
  background-color: rgba(1, 1, 1, 0.71);
}
.leaflet-popup-content {
  text-align: center;
}
.btn-popup {
  background-color: black;
  color: #ffffff;
  padding: 2px 20px 2px 20px;
  font-weight: 500;
  cursor: pointer;
}

.btn-popup:hover {
  background-color: #2f701d !important;
  color: #ffffff;
}

.tooltip-text {
  color: white;
  font-weight: 600;
}

.panel {
  align-self: center;
}
</style>
